<template>
  <nav :class="{'d-none d-md-flex' : menuOpen}"
       class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

    <!-- Sidebar Toggle (Topbar) -->
    <button @click="openMenu" id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
      <i class="fa fa-bars"></i>
    </button>

    <div class="d-none d-md-block">
      <h2 class="h5 mb-0 text-gray-800">{{ $t(orgName) }}</h2>
      <small class="d-none d-lg-block">{{ $t(orgAddress) }}</small>
    </div>

    <!-- Topbar Navbar -->
    <ul class="navbar-nav ml-auto">

      <!-- Nav Item - Search Dropdown (Visible Only XS) -->
      <li class="nav-item dropdown no-arrow d-none">
        <a class="nav-link dropdown-toggle" id="searchDropdown" role="button" data-bs-toggle="dropdown"
           aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-search fa-fw"></i>
        </a>
        <!-- Dropdown - Messages -->
        <div class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
             aria-labelledby="searchDropdown">
          <form class="form-inline mr-auto w-100 navbar-search">
            <div class="input-group">
              <input type="text" class="form-control bg-light border-0 small" placeholder="Search for..."
                     aria-label="Search" aria-describedby="basic-addon2">
              <div class="input-group-append">
                <button class="btn btn-primary" type="button">
                  <i class="fas fa-search fa-sm"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </li>

      <!-- Nav Item - Search -->
      <li class="nav-item dropdown no-arrow mx-1">
        <a class="nav-link dropdown-toggle" id="searchDropdown" role="button"
           data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-search fa-fw"></i>
        </a>
        <!-- Dropdown - Search -->
        <form @submit.prevent="globalSearch" style="min-width: 20rem"
              class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in">
          <div class="input-group">
            <input v-model="search_val" type="text" class="form-control"/>
            <div class="input-group-append">
              <button type="submit" class="btn btn-primary">
                {{ $t('Search') }}
              </button>
            </div>
          </div>
        </form>
      </li>

      <!-- Nav Item - Alerts -->
      <li class="nav-item dropdown no-arrow mx-1">
        <a class="nav-link dropdown-toggle" id="alertsDropdown" role="button"
           data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-bell fa-fw"></i>
          <!-- Counter - Alerts -->
          <span class="badge badge-danger badge-counter" v-if="notificationCount">
                        {{ $n(notificationCount) }}
                    </span>
        </a>
        <!-- Dropdown - Alerts -->
        <div style="min-width: 20rem" class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in">
          <div class="font-weight-bold">
            {{ $t('Notifications') }}
            <a v-if="notificationCount" class="link-success float-right" role="button" @click="markAllAsRead">
              {{ $t('Mark All As Read') }}
            </a>
          </div>
          <div v-if="notifications.length" class="notification-list">
            <UserNotification :item="item" v-for="item in notifications" :key="item.id"/>
          </div>
          <div class="text-center mt-2" v-else>{{ $t('No Item') }}</div>
        </div>
      </li>

      <!-- LANGUAGE -->
      <li class="nav-item" v-if="languageList.length">
        <div class="nav-link">
          <select @change="toggleLanguage" class="form-select" v-model="currentLang">
            <option :key="l.lang_code" :value="l.lang_code" v-for="l in languageList">
              {{ l.lang_name }}
            </option>
          </select>
        </div>
      </li>

      <li class="topbar-divider d-none d-sm-block"></li>

      <!-- Nav Item - User Information -->
      <li class="nav-item dropdown no-arrow">
        <a class="nav-link" v-if="currentUser"
           data-bs-toggle="dropdown" href="#" id="userDropdown" role="button"
           aria-haspopup="true" aria-expanded="false">
          <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{ currentUser?.user?.name }}</span>
          <img class="img-profile rounded-circle" :src="avatarUrl" v-if="currentUser?.user?.avatar">
          <img class="img-profile rounded-circle" src="../../../assets/img/profile.svg" v-else>
        </a>
        <!-- Dropdown - User Information -->
        <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
          <router-link to="/user-profile" class="dropdown-item">
            <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
            {{ $t('Profile') }}
          </router-link>
          <router-link to="/system-setup" v-if="currentUser?.user?.user_type_id === 1" class="dropdown-item">
            <i class="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
            {{ $t('Settings') }}
          </router-link>
          <router-link to="/change-password" class="dropdown-item">
            <i class="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
            {{ $t('Change Password') }}
          </router-link>
          <div class="dropdown-divider"></div>
          <a v-if="currentUser && currentUser.user?.user_type_id == 2" class="dropdown-item"
             :href="'cccrm://open?token=' + currentUser.token + '&lang=' + currentLang">
            <i class="fas fa-headset fa-sm fa-fw mr-2 text-gray-400"></i> {{ $t('Open Softphone App') }}
          </a>
          <a v-if="currentUser" @click.prevent="logOut" class="dropdown-item">
            <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i> {{ $t('Logout') }}
          </a>
        </div>
      </li>

    </ul>

  </nav>
</template>

<script>
import UserService from "@/services/user.service";
import UserNotification from "@/components/UserNotification.vue";
import NotificationService from "@/services/notification.service";
import {notifyError} from "@/helpers";
import aclService from "@/services/acl.service";
import TranslationService from "../../../services/translation.service";

export default {
  name: 'NavBar',
  components: {UserNotification},
  data() {
    return {
      userId: '',
      search_val: '',
      loggingOut: false,
      languageList: [],
      currentLang: 'bn',
    }
  },
  computed: {
    orgName() {
      return this.$store.state.system.settings?.site_name;
    },
    orgAddress() {
      return this.$store.state.system.settings?.company_address;
    },
    menuOpen() {
      return this.$store.state.system.menuOpen;
    },
    language() {
      return this.$store.state.system.lang;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    avatarUrl() {
      if (!this.currentUser) return null;
      return UserService.getAvatarUrl(this.currentUser.user.avatar)
    },
    notificationCount() {
      return this.$store.state.notification.count;
    },
    notifications() {
      return this.$store.state.notification.items;
    }
  },
  methods: {
    toggleLanguage() {
      let target = this.currentLang;
      this.$store.commit('system/setLanguage', target);
      //this.$i18n.locale = target;
      window.location.reload();
    },
    globalSearch() {
      this.$router.push({name: 'search', query: {q: this.search_val.trim(), t: Date.now()}});
    },
    openMenu() {
      this.$store.state.system.menuOpen = true;
    },
    logOut() {
      this.loggingOut = true;
      UserService.logout().then(({data}) => {
        if (data && data.data?.front_chanel_logout) {
          let frontChanelLogout = new URL(data.data.front_chanel_logout);
          frontChanelLogout.searchParams.append("post_logout_redirect_uri", data.data.return_url || '/');
          return frontChanelLogout;
        }
      }).then(d => {
        window.location.href = (d || '/');
      }).catch(e => {
        console.log(e);
        window.location.reload();
      }).finally(() => {
        //this.$store.dispatch('auth/logout');
      });
    },
    fetchNotifications() {
      NotificationService.getItems().then(d => {
        let items = d.data.data.map(i => ({
          ...i, data: JSON.parse(i.data)
        }));
        this.$store.dispatch('notification/addItems', items, d.data.total);
      }).catch(e => notifyError(e))
    },
    fetchLanguageList() {
      TranslationService.getLanguageList().then(d => {
        this.languageList = d.data.data;
      }).catch(e => notifyError(e))
    },
    onNewNotification({notification}) {
      this.$store.dispatch('notification/addItems', [{...notification, data: JSON.parse(notification.data)}], 1);
    },
    onUserLogout() {
      if (!this.loggingOut) {
        aclService.fetchUserRolesAndMenus().catch(e => {
          console.log(e)
          //notifyError(e);
          this.logOut();
        });
      }
    },
    markAllAsRead() {
      this.$store.dispatch('notification/markAllAsRead');
    }
  },
  mounted() {
    this.fetchNotifications();
    this.fetchLanguageList();
    this.userId = this.currentUser.user.id;
    window.Echo?.private('Notification.' + this.userId).listen('NotificationCreated', this.onNewNotification);
    this.search_val = this.$route.query.q || '';
    window.Echo?.private('Logout.' + this.userId).listen('UserLoggedOut', this.onUserLogout);
    this.currentLang = this.language;
  },
  beforeUnmount() {
    window.Echo?.private('Notification.' + this.userId).stopListening('NotificationCreated', this.onNewNotification);
    this.$store.dispatch('notification/clearItems');
    window.Echo?.private('Logout.' + this.userId).stopListening('UserLoggedOut', this.onUserLogout);
  },
  watch: {
    '$route': function () {
      this.search_val = (this.$route.query.q || '').trim();
    },
    language: function (newVal) {
      this.currentLang = newVal;
    },
  }
};
</script>
<style>
.notification-list {
  max-height: calc(100vh - 10rem);
  overflow: auto;
}
</style>